import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { MUTUAL_FUNDS_FUND_ORDER_BASE_PATH } from '../../../../../features/mutual-funds/fund-order/mutual-funds-fund-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/order/mutual-fund/_mutual-fund')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'mutual-fund-order-list',
        label: 'Orders',
        to: MUTUAL_FUNDS_FUND_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
